import * as types from "store/login/loginTypes";

const initialState = {
  showLoginFailed: false,
  loginSuccessed: false,
  longToken: false,
  loading: false,
  roles: [],
  terms: '',
  isOpen: (window.location.href.indexOf("change-password") != -1) || (window.location.href.indexOf("reset-password") != -1),
  showAcceptTermsMessage: false,
  showErrorMessage: false,
  allAccountsList: [{id: 1, value: 'All Accounts'}, {id: 2, value: 'US Accounts Only'}, {id: 3, value: 'EU Accounts Only'}],
  accountsSelected: false ,
  allClientsList: [],
  clientsSelected: false ,
  isI2andQsToolUserModalOpen: false,
  isSubmitting: false

};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.POST_LOGIN_REQUESTED:
      return {
        ...state,
        ...action.payload,
        loading: true,
      };
      case types.POST_LOGIN_REQUEST_FAILED:
        return {
          ...state,
          ...action.payload,
          showLoginFailed: true,
          loading: false,
        };
        case types.POST_LOGIN_REQUEST_SUCCESSED:
            return {
             ...state,
             ...action.payload,
              loginSuccessed: true,
              loading: false,
              roles: action.roles,
              accountsSelected: action.accountsSelected? true: false,
              clientsSelected: action.accountsSelected? true: false
            };
        case types.POST_ADMIN_LOGIN_REQUEST_SUCCEEDED:
          return {
           ...state,
           ...action.payload,
            loginSuccessed: true,
            loading: false,
            roles: action.roles
          };
        case types.UPDATE_ACCOUNT_SELECTION_SUCCEEDED:
          return {
            ...state,
            allClientsList: action.payload.data.data
          }
        case types.SET_ACCOUNTS_SELECTED:
          return {
            ...state,
            accountsSelected: action.payload.accountsSelected,
            clientsSelected: action.payload.clientsSelected? action.payload.clientsSelected : state.clientsSelected
          };
        case types.SET_CLIENTS_SELECTED:
        return {
          ...state,
          clientsSelected: action.payload.clientsSelected
        };
        case types.POST_LOGIN_TERMS_NOT_ACCEPTED:
            return {
              ...state,
              ...action.payload,
              loginSuccessed: false,
              loading: false,
              terms: action.terms
            };
        
        case types.POST_UPDATE_PASSWORD_REQUESTED:
          return {  
            ...state,    
            isOpen: true,
            loading: true,
            showAcceptTermsMessage: false,
          };
        case types.POST_UPDATE_PASSWORD_SUCCESSED:
          return {
            ...state,
            isOpen: true,
            loading: false,
            showAcceptTermsMessage: true,
            status: action.status,
          };
        case types.CLOSE_RESET_PASSWORD_MODAL:
          return {
            ...state,
            isOpen: false,
            loading: false,
            showAcceptTermsMessage: false,
          };
        case types.POST_UPDATE_PASSWORD_FAILED:
          if (action.status === 400 || action.status === 403 || action.status === 401) {
            return {
              ...state,
              isOpen: true,
              loading: false,
              showAcceptTermsMessage: false,
              showErrorMessage: true,
              status: action.status,
            };
          } else {
            return {
              ...state,
              isOpen: true,
              loading: false,
              showAcceptTermsMessage: false,
              showErrorMessage: false,
              status: action.status,
            };
          }
    case types.SEND_RESET_PASSWORD_EMAIL_REQUESTED:
      return {
        ...state,
        isSubmitting: true,
        // QUAL-2135: cleared here because the removed IS_I2_AND_QS_TOOL_USER_REQUESTED case
        // used to do it at the start of each attempt. Without it emailSent stays true after
        // the first send, so the login screen's confirmation never re-renders on a second
        // request in the same session.
        emailSent: false,
      }
    case types.SEND_RESET_PASSWORD_EMAIL_SUCCESSED:
      return {
        ...state,
        isSubmitting: false,
        emailSent: true,
      }
    case types.SEND_RESET_PASSWORD_EMAIL_FAILED:
      return {
        ...state,
        isSubmitting: false,
      };
    case types.TOGGLE_I2_AND_QS_TOOL_USER_MODAL:
      return {
        ...state,
        loading: false,
        isI2andQsToolUserModalOpen: !state.isI2andQsToolUserModalOpen,
      };
    default:
      return state;
  }
};

export default loginReducer
